module.exports = __webpack_public_path__ + "assets/img/order-head-back1.cba19974.png";